import { isEditableElement } from "@/utils/dom";
import { useCallback, useEffect } from "react";

/**
 * Enables capturing the [ key to toggle the sidebar
 */
export const useSidebarToggleShortcut = (setTriggered: (value: boolean) => void) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "[") {
                return;
            }

            if (event.metaKey || event.ctrlKey) {
                return;
            }

            if (isEditableElement(event.target)) {
                return;
            }

            if (event.defaultPrevented) {
                return;
            }
            event.preventDefault();
            setTriggered(true);
        },
        [setTriggered],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
